import { render, staticRenderFns } from "./notFount.vue?vue&type=template&id=e28a94fa&scoped=true&"
import script from "./notFount.vue?vue&type=script&lang=js&"
export * from "./notFount.vue?vue&type=script&lang=js&"
import style0 from "./notFount.vue?vue&type=style&index=0&id=e28a94fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a94fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e28a94fa')) {
      api.createRecord('e28a94fa', component.options)
    } else {
      api.reload('e28a94fa', component.options)
    }
    module.hot.accept("./notFount.vue?vue&type=template&id=e28a94fa&scoped=true&", function () {
      api.rerender('e28a94fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/notFount.vue"
export default component.exports